import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { ScoreOption } from '@features/tournament/ui/components/TournamentSettings/inputs/AdditonalScoreInput';
import { useDeduplicateScoreOptions } from '@features/tournament/ui/components/TournamentSettings/inputs/useDeduplicateScoreOptions';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const privateTeamScoreTeamOptions: ScoreOption[] = [
  { value: '', label: '' },
  { value: 'IndividualBuchholzSum', label: 'Сумма личных Бухгольцев' },
  { value: 'IndividualPlaceSum', label: 'Сумма мест' },
];

export function PrivateTeamAdditionalScoreInput() {
  const { control, setValue } = useFormContext<TournamentEditFormValues>();
  const [scores] = useWatch({
    name: ['privateTeamModeSettings.tieBreakers', 'system'],
    control,
  });

  const options = privateTeamScoreTeamOptions;

  useDeduplicateScoreOptions(options, setValue, 'privateTeamModeSettings.tieBreakers', scores);

  return (
    <FormRow>
      <FormLabel>Доп. коэффициенты в командный зачет</FormLabel>
      <FormInput>
        <Controller
          name="privateTeamModeSettings.tieBreakers.0"
          control={control}
          render={(field) => (
            <Dropdown
              options={options}
              value={field.field.value}
              onChange={field.field.onChange}
              disabled={field.field.disabled}
            />
          )}
        />
        <Controller
          name="privateTeamModeSettings.tieBreakers.1"
          control={control}
          render={(field) => (
            <Dropdown
              options={options}
              value={field.field.value}
              onChange={field.field.onChange}
              disabled={field.field.disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
